export const blogPosts = (state) => {
  return state.blogPosts
}
